export const GET_COURSE_FILE = "GET_COURSE_FILE";
export const GET_COURSE_FILE_SUCCESS = "GET_COURSE_FILE_SUCCESS";
export const GET_COURSE_FILE_ERROR = "GET_COURSE_FILE_ERROR";
export const RESET_GET_COURSE_FILE = "RESET_COURSE_FILE_STATICS";

export interface GetCourseFile {
  type: typeof GET_COURSE_FILE;
  payload: any;
}

export interface GetCourseFileSuccess {
  type: typeof GET_COURSE_FILE_SUCCESS;
  payload: any;
}

export interface GetCourseFileError {
  type: typeof GET_COURSE_FILE_ERROR;
  payload: any;
}

export interface ResetGetCourseFile {
  type: typeof RESET_GET_COURSE_FILE;
  payload: null;
}

export interface State {
  data: File | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | GetCourseFile
  | GetCourseFileSuccess
  | GetCourseFileError
  | ResetGetCourseFile;